/* Auto GoShop storefront scripts */
(function () {
  'use strict';
  var A = window.AGS || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || A.moneyFormat || '${{amount}}';
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, prec, th, dec) {
      th = th === undefined ? ',' : th; dec = dec === undefined ? '.' : dec;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(rx); var out = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': out = fmt(cents, 2); break;
      case 'amount_no_decimals': out = fmt(cents, 0); break;
      case 'amount_with_comma_separator': out = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fmt(cents, 2, "'", '.'); break;
      default: out = fmt(cents, 2);
    }
    return format.replace(rx, out);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    closeAllMega();
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    $$('[data-open-drawer]').forEach(function (el) { if (el.getAttribute('data-open-drawer') === id) el.setAttribute('aria-expanded', 'true'); });
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('button, a, input, select'); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    $$('[data-open-drawer]').forEach(function (el) { if (el.getAttribute('data-open-drawer') === d.id) el.setAttribute('aria-expanded', 'false'); });
    if (!$('.drawer.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open-drawer')); return; }
    var c = e.target.closest('[data-close-drawer]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('[data-drawer]')); }
  });

  /* ---------- mega menu: one open at a time ---------- */
  function closeAllMega(except) {
    $$('[data-mega-toggle]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var m = document.getElementById(b.getAttribute('aria-controls')); if (m) m.classList.remove('is-open');
    });
  }
  $$('[data-mega-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeAllMega(btn);
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var m = document.getElementById(btn.getAttribute('aria-controls'));
      if (m) m.classList.toggle('is-open', !open);
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mega]') && !e.target.closest('[data-mega-toggle]')) closeAllMega();
    if (!e.target.closest('[data-predictive]')) closePredict();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openBtn = $('[data-mega-toggle][aria-expanded="true"]');
    closeAllMega(); closePredict();
    if (openBtn) openBtn.focus();
    var d = $('.drawer.is-open'); if (d) closeDrawer(d);
  });
  // mobile accordions: one open per level
  $$('[data-mnav-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var li = b.parentElement, list = li.parentElement;
      var open = b.getAttribute('aria-expanded') === 'true';
      $$(':scope > li > [data-mnav-toggle]', list).forEach(function (x) {
        x.setAttribute('aria-expanded', 'false');
        var s = x.nextElementSibling; if (s) s.classList.remove('is-open');
      });
      if (!open) { b.setAttribute('aria-expanded', 'true'); var sub = b.nextElementSibling; if (sub) sub.classList.add('is-open'); }
    });
  });
  // mobile search toggle
  var st = $('[data-toggle-search]');
  if (st) st.addEventListener('click', function () {
    var f = $('.hdr__search'); f.classList.toggle('is-mobile-open');
    if (f.classList.contains('is-mobile-open')) $('input[type=search]', f).focus();
  });

  /* ---------- predictive search ---------- */
  var pForm = $('[data-predictive]'), pBox = pForm && $('.predict', pForm), pInput = pForm && $('input[type=search]', pForm), pTimer;
  function closePredict() { if (pBox) { pBox.classList.remove('is-open'); if (pInput) pInput.setAttribute('aria-expanded', 'false'); } }
  if (pInput) {
    pInput.addEventListener('input', function () {
      clearTimeout(pTimer);
      var q = pInput.value.trim();
      if (q.length < 2) { closePredict(); return; }
      pTimer = setTimeout(function () {
        fetch((A.routes.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = d.resources && d.resources.results || {};
            var html = '';
            (res.collections || []).slice(0, 3).forEach(function (c) { html += '<a class="predict__q" href="' + c.url + '"><span>Category: <strong>' + esc(c.title) + '</strong></span></a>'; });
            if ((res.products || []).length) html += '<div class="predict__head">Products</div>';
            (res.products || []).forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
              html += '<a href="' + p.url + '" role="option">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') + '<span>' + esc(p.title) + '<br><strong>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</strong></span></a>';
            });
            if (!html) html = '<div class="predict__head">No quick matches — press Enter to search</div>';
            html += '<a class="predict__all" href="' + A.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">See all results for “' + esc(q) + '”</a>';
            pBox.innerHTML = html; pBox.classList.add('is-open'); pInput.setAttribute('aria-expanded', 'true');
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- product cards: image swatches ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sw-img]'); if (!sw) return;
    var card = sw.closest('[data-card]'); if (!card) return;
    e.preventDefault();
    var img = $('[data-card-img]', card);
    if (img) { img.removeAttribute('srcset'); img.src = sw.getAttribute('data-sw-img'); }
    $$('[data-card-link]', card).forEach(function (a) { a.href = sw.getAttribute('data-sw-url'); });
    $$('.sw', card).forEach(function (x) { x.classList.toggle('is-active', x === sw); });
  });
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-sw-img]'); if (!sw || window.matchMedia('(hover: none)').matches) return;
    var card = sw.closest('[data-card]'); var img = card && $('[data-card-img]', card);
    if (img) { img.removeAttribute('srcset'); img.src = sw.getAttribute('data-sw-img'); }
  });

  /* ---------- cart ---------- */
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    $$('[data-open-cart]').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + n + ' items'); });
  }
  function renderMiniCart(cart) {
    var body = $('[data-mc-body]'), foot = $('[data-mc-foot]'); if (!body) return;
    updateCount(cart.item_count);
    if (!cart.item_count) {
      var back = continueUrl() || (A.routes.root || '/');
      body.innerHTML = '<div class="mc-empty"><p>Your cart is empty.</p><a class="btn btn--primary" href="' + back + '">Continue shopping</a></div>';
      foot.hidden = true; return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
      return '<div class="mc-item"><a href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a><div><a class="mc-item__t" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
        (opts ? '<div class="mc-item__o">' + opts + '</div>' : '') +
        '<div class="mc-item__r"><div class="qty" style="height:34px;grid-template-columns:30px 40px 30px"><button type="button" data-mc-q="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button><input type="number" value="' + it.quantity + '" aria-label="Quantity" readonly><button type="button" data-mc-q="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div><strong>' + formatMoney(it.final_line_price) + '</strong></div>' +
        '<button type="button" class="ci__remove" data-mc-q="' + (i + 1) + '" data-q="0" style="margin-top:6px">Remove</button></div></div>';
    }).join('');
    $('[data-mc-subtotal]').textContent = formatMoney(cart.items_subtotal_price);
    foot.hidden = false;
  }
  function fetchCart() { return fetch((A.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(line, qty) {
    return fetch((A.routes.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-mc-q]'); if (!q) return;
    q.disabled = true;
    changeLine(parseInt(q.getAttribute('data-mc-q'), 10), Math.max(0, parseInt(q.getAttribute('data-q'), 10))).then(renderMiniCart);
  });
  $$('[data-open-cart]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (A.template === 'cart') return;
      e.preventDefault(); fetchCart().then(function (c) { renderMiniCart(c); openDrawer('cart-drawer'); });
    });
  });

  /* ---------- continue shopping ---------- */
  function continueUrl() {
    var now = Date.now(), wk = 1000 * 60 * 60 * 24 * 14;
    var p = store.get('ags:lastProduct'); if (p && p.url && now - p.ts < wk) return p.url;
    var c = store.get('ags:lastCollection'); if (c && c.url && now - c.ts < wk) return c.url;
    return null;
  }
  if (A.template === 'collection') {
    var cEl = $('[data-collection]');
    if (cEl) store.set('ags:lastCollection', { url: location.pathname + location.search, ts: Date.now() });
  }
  $$('[data-continue]').forEach(function (a) { var u = continueUrl(); if (u) a.href = u; });

  /* ---------- cart page ---------- */
  var cp = $('[data-cart-page]');
  if (cp) {
    $$('.ci', cp).forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line'), 10), inp = $('[data-ci-qty]', row);
      function go(q) { row.style.opacity = '.5'; changeLine(line, q).then(function () { location.reload(); }); }
      $('[data-ci-minus]', row).addEventListener('click', function () { go(Math.max(0, parseInt(inp.value, 10) - 1)); });
      $('[data-ci-plus]', row).addEventListener('click', function () { go(parseInt(inp.value, 10) + 1); });
      inp.addEventListener('change', function () { go(Math.max(0, parseInt(inp.value, 10) || 0)); });
      $('[data-ci-remove]', row).addEventListener('click', function (e) { e.preventDefault(); go(0); });
    });
  }

  /* ---------- collection sort / filters ---------- */
  var sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u.toString();
  });
  $$('[data-facets]').forEach(function (f) {
    f.addEventListener('change', function () {
      var fd = new FormData(f), params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var base = f.getAttribute('action');
      location.href = base + (base.indexOf('?') > -1 ? '&' : '?') + params.toString();
    });
  });

  /* ---------- FAQ ---------- */
  var faq = $('[data-faq]');
  if (faq) {
    var fq = $('[data-faq-q]', faq), empty = $('[data-faq-empty]', faq);
    fq.addEventListener('input', function () {
      var q = fq.value.trim().toLowerCase(), any = false;
      $$('[data-faq-group]', faq).forEach(function (g) {
        var groupAny = false;
        $$('[data-faq-item]', g).forEach(function (it) {
          var hit = !q || it.textContent.toLowerCase().indexOf(q) > -1;
          it.style.display = hit ? '' : 'none';
          if (q && hit) it.open = true; if (!q) it.open = false;
          if (hit) groupAny = true;
        });
        g.style.display = groupAny ? '' : 'none'; if (groupAny) any = true;
      });
      empty.style.display = any ? 'none' : 'block';
    });
    if (location.hash) { var t = document.getElementById(location.hash.slice(1)); if (t && t.tagName === 'DETAILS') t.open = true; }
  }

  /* ---------- contact prefill ---------- */
  var cpf = $('[data-contact-product]');
  if (cpf) {
    var prod = new URLSearchParams(location.search).get('product');
    if (prod) {
      cpf.value = prod;
      var ta = $('#cf-body'); if (ta && !ta.value) ta.value = 'Question about product: ' + prod.replace(/-/g, ' ') + '\n\n';
    }
    if (location.search.indexOf('contact_posted=true') > -1) { var fm = $('#contact-form'); if (fm) fm.scrollIntoView(); }
  }

  /* ---------- product page ---------- */
  $$('[data-pdp]').forEach(function (root) {
    var sid = root.getAttribute('data-section');
    var dataEl = document.querySelector('[data-product-json="' + sid + '"]'); if (!dataEl) return;
    var P = JSON.parse(dataEl.textContent);
    var form = $('[data-product-form]', root) || $('form[action*="/cart/add"]', root);
    var idInput = $('[data-variant-id]', root);
    var mainBox = $('[data-gallery-main]', root);
    var thumbs = $$('[data-thumb]', root);
    var count = $('[data-g-count]', root);
    var mediaIndex = {}; P.media.forEach(function (m, i) { mediaIndex[m.id] = i; });
    var curMediaIdx = 0;
    var fieldsets = $$('[data-opt]', root);
    var selected = [];
    var current = null;
    var compoundPicker = $('[data-compound-picker]', root);
    var compoundGroups = compoundPicker ? $$('[data-choice-group]', compoundPicker) : [];
    var compoundReady = false;
    function splitChoice(value) { return value.split(' - '); }
    function paintCompound() {
      if (!compoundReady) return;
      var parts = splitChoice(selected[0]);
      compoundGroups.forEach(function (group, index) {
        $('[data-choice-label]', group).textContent = parts[index];
        $$('[data-choice-value]', group).forEach(function (button) {
          var active = button.dataset.choiceValue === parts[index];
          var combination = parts.slice(); combination[index] = button.dataset.choiceValue;
          var match = findVariant([combination.join(' - ')]);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
          button.disabled = !match || !match.available;
          button.classList.toggle('is-unavail', button.disabled);
        });
      });
      $('[data-choice-summary]', compoundPicker).textContent = P.choiceHelp[parts[0]] || '';
    }
    function setupCompound() {
      if (!compoundPicker || !P.compoundKind || P.options.length !== 1) return;
      if (!P.variants.every(function (variant) { return splitChoice(variant.options[0]).length === 2; })) return;
      compoundGroups.forEach(function (group, index) {
        var values = [];
        P.variants.forEach(function (variant) {
          var value = splitChoice(variant.options[0])[index];
          if (values.indexOf(value) < 0) values.push(value);
        });
        values.forEach(function (value) {
          var button = document.createElement('button');
          button.type = 'button'; button.className = 'opt__btn';
          button.dataset.choiceValue = value; button.textContent = value;
          button.addEventListener('click', function () {
            var parts = splitChoice(selected[0]); parts[index] = value;
            select(0, parts.join(' - '), true);
          });
          $('[data-choice-buttons]', group).appendChild(button);
        });
      });
      compoundReady = true;
      fieldsets.forEach(function (fieldset) { fieldset.hidden = true; });
      compoundPicker.hidden = false;
    }

    function findVariant(opts) {
      for (var i = 0; i < P.variants.length; i++) {
        var v = P.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function initSelected() {
      var qid = new URLSearchParams(location.search).get('variant');
      var v = null;
      if (qid) v = P.variants.filter(function (x) { return String(x.id) === qid; })[0];
      if (!v) v = P.variants.filter(function (x) { return String(x.id) === idInput.value; })[0] || P.variants[0];
      selected = v.options.slice();
    }
    function showMedia(idx, fromUser) {
      if (idx == null || !P.media[idx]) return;
      curMediaIdx = idx;
      var m = P.media[idx];
      var old = $('.gallery__video', mainBox); if (old) old.remove();
      var img = $('[data-main-img]', mainBox);
      if (m.type === 'image' || !m.html) {
        if (img) { img.style.display = ''; img.srcset = m.s700 + ' 700w, ' + m.s1100 + ' 1100w, ' + m.src + ' 1400w'; img.src = m.src; img.alt = m.alt || ''; }
      } else {
        if (img) img.style.display = 'none';
        var wrap = document.createElement('div'); wrap.className = 'gallery__video'; wrap.innerHTML = m.html; mainBox.appendChild(wrap);
      }
      thumbs.forEach(function (t) { var a = String(t.getAttribute('data-media-id')) === String(m.id); t.classList.toggle('is-active', a); if (a && fromUser !== 'thumb') t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
      if (count) count.textContent = (idx + 1) + ' / ' + P.media.length;
    }
    function availabilityFor(optIdx, val) {
      var test = selected.slice(); test[optIdx] = val;
      var v = findVariant(test);
      if (v) return v.available ? 'ok' : 'soldout';
      var any = P.variants.some(function (x) { return x.options[optIdx] === val && x.available; });
      return any ? 'combo' : 'soldout';
    }
    function paintOptions() {
      paintCompound();
      fieldsets.forEach(function (fs) {
        var oi = parseInt(fs.getAttribute('data-opt'), 10);
        var lab = $('[data-opt-label]', fs); if (lab) lab.textContent = selected[oi];
        $$('.opt__btn', fs).forEach(function (b) {
          var val = b.getAttribute('data-val'); var act = val === selected[oi];
          b.classList.toggle('is-active', act); b.setAttribute('aria-pressed', act ? 'true' : 'false');
          var av = availabilityFor(oi, val);
          b.classList.toggle('is-unavail', av !== 'ok');
          b.title = av === 'ok' ? val : (av === 'soldout' ? val + ' — sold out' : val + ' — not available with current selection');
        });
      });
    }
    function paintVariant(v, changeImage) {
      current = v;
      var atc = $('[data-atc]', root), lbl = $('[data-atc-label]', root), stock = $('[data-stock]', root), price = $('[data-price]', root), save = $('[data-save]', root);
      if (!v) {
        if (atc) atc.disabled = true; if (lbl) lbl.textContent = 'Unavailable';
        if (stock) { stock.className = 'stock stock--out'; stock.textContent = 'This combination is not available'; }
        return;
      }
      idInput.value = v.id;
      if (atc) atc.disabled = !v.available; if (lbl) lbl.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (stock) {
        if (!v.available) { stock.className = 'stock stock--out'; stock.textContent = 'Sold out'; }
        else if (v.qty !== null && v.qty > 0 && v.qty <= 5) { stock.className = 'stock stock--low'; stock.textContent = 'In stock — only ' + v.qty + ' left'; }
        else { stock.className = 'stock'; stock.textContent = 'In stock'; }
      }
      if (price) {
        var sale = v.compare > v.price;
        price.className = 'price' + (sale ? ' price--sale' : '');
        price.innerHTML = '<span class="price__now">' + formatMoney(v.price) + '</span>' + (sale ? '<s>' + formatMoney(v.compare) + '</s>' : '');
        if (save) { save.hidden = !sale; save.textContent = sale ? 'Save ' + formatMoney(v.compare - v.price) : ''; }
      }
      if (changeImage && v.media && mediaIndex[v.media] != null) showMedia(mediaIndex[v.media]);
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      store.set('ags:lastProduct', { url: P.url + '?variant=' + v.id, ts: Date.now() });
    }
    function select(oi, val, changeImage) {
      selected[oi] = val;
      var v = findVariant(selected);
      if (!v) {
        // combination does not exist: keep chosen value, adjust other options to the closest existing (preferably available) variant
        var cands = P.variants.filter(function (x) { return x.options[oi] === val; });
        var best = null, bestScore = -1;
        cands.forEach(function (x) {
          var score = (x.available ? 100 : 0);
          for (var j = 0; j < selected.length; j++) if (x.options[j] === selected[j]) score++;
          if (score > bestScore) { bestScore = score; best = x; }
        });
        if (best) { selected = best.options.slice(); v = best; }
      }
      paintOptions(); paintVariant(v, changeImage);
    }
    setupCompound();
    initSelected();
    paintOptions();
    paintVariant(findVariant(selected), true);

    fieldsets.forEach(function (fs) {
      var oi = parseInt(fs.getAttribute('data-opt'), 10);
      $$('.opt__btn', fs).forEach(function (b) {
        b.addEventListener('click', function () { select(oi, b.getAttribute('data-val'), true); });
      });
    });
    // gallery browsing; a thumbnail that is a variant image selects that colour (other options kept when possible)
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var mid = parseInt(t.getAttribute('data-media-id'), 10);
        showMedia(mediaIndex[mid], 'thumb');
        if (P.colorIndex > -1) {
          var owners = P.variants.filter(function (v) { return v.media === mid; });
          if (owners.length) {
            var vals = owners.map(function (v) { return v.options[P.colorIndex]; });
            var uniq = vals.filter(function (x, i) { return vals.indexOf(x) === i; });
            if (uniq.length === 1 && uniq[0] !== selected[P.colorIndex]) select(P.colorIndex, uniq[0], false);
          }
        }
      });
    });
    var prev = $('[data-g-prev]', root), next = $('[data-g-next]', root);
    if (prev) prev.addEventListener('click', function () { showMedia((curMediaIdx - 1 + P.media.length) % P.media.length); });
    if (next) next.addEventListener('click', function () { showMedia((curMediaIdx + 1) % P.media.length); });
    // swipe on mobile
    var sx = null;
    mainBox.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    mainBox.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40 && P.media.length > 1) showMedia((curMediaIdx + (dx < 0 ? 1 : -1) + P.media.length) % P.media.length);
    });
    // quantity
    var qi = $('[data-qty]', root);
    var qm = $('[data-qty-minus]', root), qp = $('[data-qty-plus]', root);
    if (qm) qm.addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); });
    if (qp) qp.addEventListener('click', function () { qi.value = Math.min(99, (parseInt(qi.value, 10) || 1) + 1); });
    // add to cart
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var atc = $('[data-atc]', root), msg = $('[data-atc-msg]', root), lbl = $('[data-atc-label]', root);
      if (!current || !current.available) return;
      atc.disabled = true; lbl.textContent = 'Adding…'; msg.textContent = ''; msg.className = 'buy__msg';
      fetch((A.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: Math.max(1, parseInt(qi.value, 10) || 1) }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetchCart(); })
        .then(function (c) { renderMiniCart(c); openDrawer('cart-drawer'); lbl.textContent = 'Add to cart'; atc.disabled = false; })
        .catch(function (err) { msg.textContent = (err && (err.description || err.message)) || 'Sorry, this item could not be added. Please try again.'; msg.className = 'buy__msg is-err'; lbl.textContent = 'Add to cart'; atc.disabled = false; });
    });
  });
})();
